/**
 * @typedef {Object} RoleLookupDto
 * @property {number} roleId
 * @property {string} roleCode
 * @property {string} roleName
 * @property {string} [description]
 * @property {boolean} isSystem
 * @property {number} permissionCount
 */

const BASE_PATH = 'v1/Role';

export default function (instance) {
  return {
    getRoleLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    }
  };
}
